import PropTypes from "prop-types";

/**
 * The bar above a record page: breadcrumb and title on the left, with an
 * optional muted subtitle beside the title, and optional actions on the right.
 * Shared by SidebarDetailLayout and the full-page record forms so both read as
 * the same page chrome.
 */
const DetailHeaderBar = ({ breadcrumb, title, subtitle, actions }) => (
  <div className="tw:flex tw:shrink-0 tw:items-center tw:justify-between tw:gap-2 tw:border-b tw:border-[var(--color-border)] tw:bg-[var(--color-surface)] tw:px-4 tw:py-2">
    <div className="tw:flex tw:min-w-0 tw:flex-col">
      {breadcrumb}
      {title && (
        <div className="tw:flex tw:min-w-0 tw:items-baseline tw:gap-3">
          <h2 className="tw:m-0! tw:shrink-0 tw:font-heading tw:text-xl! tw:text-foreground">
            {title}
          </h2>
          {subtitle && (
            <p className="tw:m-0 tw:truncate tw:text-sm tw:text-(--color-text-muted)">
              {subtitle}
            </p>
          )}
        </div>
      )}
    </div>
    {actions && (
      <div className="tw:flex tw:shrink-0 tw:items-center tw:gap-2">
        {actions}
      </div>
    )}
  </div>
);

DetailHeaderBar.propTypes = {
  breadcrumb: PropTypes.node,
  title: PropTypes.node,
  subtitle: PropTypes.node,
  actions: PropTypes.node,
};

export default DetailHeaderBar;
